import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lmM3uFilesApi = createApi({
  reducerPath: 'lmM3uFilesApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['M3U files'],
  endpoints: builder => ({
    getM3uFiles: builder.query({
      query: (params) => ({
        url: `/links/m3u-files/`,
        params,
      }),
      providesTags: ['M3U files'],
    }),

    createM3uFile: builder.mutation({
      query: (data) => ({
        url: '/links/m3u-files/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['M3U files'],
    }),
    updateM3uFile: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/m3u-files/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['M3U files'],
    }),
    getM3uFileById: builder.query({
      query: ({ id, ...params }) => ({
        url: `/links/m3u-files/${id}/`,
        params,
      }),
      providesTags: ['M3U files']
    }),
  }),
});

export const {
  useGetM3uFilesQuery,
  useLazyGetM3uFilesQuery,
  useCreateM3uFileMutation,
  useUpdateM3uFileMutation,
  useGetM3uFileByIdQuery
} = lmM3uFilesApi;
